import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
export default function EnglishIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-testid": "icon-english",
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_1044:40658)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F47782",
    d: "M5.348 49.138l51.43-6.364.454 3.674-51.43 6.364z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.518 45.718l-46.26 5.725a1.017 1.017 0 01-1.135-.885l-.33-2.664 48.28-5.974.33 2.663a1.018 1.018 0 01-.885 1.135z",
    fill: "#70A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58 18.706c8.918-2.114 19.2-1.123 23.543-.28l3.74 30.22c-5.903-1.052-15.984-.413-22.451.741-1.843.329-3.678-.906-3.908-2.763l-3.06-24.725c-.18-1.46.704-2.854 2.136-3.193z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.54 12.899c-9.362.136-19.32 3.637-23.417 5.526l3.74 30.22c5.607-2.483 15.804-4.352 22.49-4.815 1.863-.13 3.336-1.772 3.106-3.625L53.4 15.479c-.18-1.465-1.384-2.602-2.86-2.58z",
    fill: "#BED9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.803 52.812l51.429-6.364c.072.58-.34 1.108-.92 1.18l-49.33 6.104a1.058 1.058 0 01-1.18-.92z",
    fill: "#F47782"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.647,
    cy: 50.679,
    rx: 2.644,
    ry: 1.058,
    transform: "rotate(-7.054 31.647 50.68)",
    fill: "#F47782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.069 22.674c3.827-.651 12.647-1.565 17.315-.012M7.341 32.959c3.827-.651 12.648-1.565 17.316-.011M6.692 27.711c3.827-.65 12.647-1.565 17.315-.011M7.99 38.207c3.828-.652 12.648-1.566 17.316-.012M8.64 43.454c3.827-.651 12.648-1.565 17.316-.011M49.85 27.699c-3.871.301-12.648 1.565-16.797 4.21M49.2 22.45c-3.87.302-12.647 1.566-16.795 4.21M50.498 32.946c-3.87.302-12.647 1.565-16.795 4.21",
    stroke: "#579FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.272 39.155L43.148 5.831c-6.22 1.41-12.943 8.795-15.527 12.312l3.799 30.7c3.705-4.508 12.111-8.337 15.852-9.688z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.685 43.311L9.561 9.987c6.376-.15 14.696 5.375 18.06 8.156l3.799 30.7c-4.692-3.47-13.778-5.133-17.735-5.532z",
    fill: "#D0E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.745 49.135c-4.767-3.492-14.004-5.16-18.027-5.557L9.561 9.988c7.887.844 18.352 7.899 18.352 7.899 5.072-6.686 8.344-9.682 15.943-11.863L47.999 38.5",
    stroke: "#579FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.62 18.142l3.8 30.7M31.42 48.843c2.8-1.768 11.444-5.253 23.617-5.054",
    stroke: "#579FFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.74,
    cy: 22.159,
    r: 1,
    transform: "rotate(-.639 15.74 22.159)",
    fill: "#579FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#579FFF",
    strokeWidth: 2,
    d: "M18.656 22.293l8.975.667"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.444,
    cy: 26.145,
    r: 1,
    transform: "rotate(-.639 16.444 26.145)",
    fill: "#579FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#579FFF",
    strokeWidth: 2,
    d: "M19.36 26.28l6.981.518"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.148,
    cy: 30.132,
    r: 1,
    transform: "rotate(-.639 17.148 30.132)",
    fill: "#579FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#579FFF",
    strokeWidth: 2,
    d: "M20.058 30.419l5.984.444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.225 36.838l-2.33-2.197 22.204-23.914a1.586 1.586 0 012.255-.075c.643.607.677 1.624.075 2.272L27.225 36.838zM23.638 39.11c-.439.27-.952-.214-.714-.673l1.97-3.796 2.372 2.236-3.628 2.233z",
    fill: "#1E6DEB"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_1044:40658"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  }))));
}